import React, { useState } from 'react'
import { Empty, Table } from 'antd'
import styles from '../../styles/sales.module.scss'

const ProductOptionComponent = ({
  optionList,
  handleOptionRowEvent,
  selectedProductRowKeys,
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const optionColumns = [
    {
      title: '옵션명',
      width: 150,
      dataIndex: 'optionTitle',
      key: 'optionTitle',
      ellipsis: true,
      render: (value) => (
        <p
          style={{
            width: '100%',
            fontSize: '1em',
            margin: 0,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }}
        >
          {value}
        </p>
      ),
    },
    {
      title: '가격',
      width: 100,
      dataIndex: 'price2',
      key: 'price2',
      ellipsis: true,
      render: (value) => {
        return value.toLocaleString()
      },
    },
    {
      title: '박스 당 가격',
      width: 150,
      dataIndex: 'optionDescription',
      key: 'optionDescription',
      ellipsis: true,
    },
  ]

  return (
    <div className={`${styles['order-component-each-detail']}`}>
      <h4 className={`${styles['order-each-detail-title']}`}>옵션 설정</h4>
      {/*옵션 목록*/}
      <Table
        className={`${styles['order-create-product-list-table']} ${styles['order-create-product-option-list-table']}`}
        columns={optionColumns}
        dataSource={optionList.total}
        loading={isLoading}
        bordered
        size="middle"
        rowKey="id"
        rowClassName="coupon-table-row"
        // scroll={{y: 'calc(191px - 48px)'}}
        // scroll={{x: true}}
        onRow={handleOptionRowEvent}
        // tableLayout="auto"
        pagination={false}
        locale={{
          emptyText:
            selectedProductRowKeys?.length !== 0 ? (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  optionList.total?.length === 0
                    ? '선택하신 상품에 등록된 옵션이 없습니다.'
                    : optionList.except?.length === 0
                      ? '선택하신 상품에 해당하는 옵션들을 이미 선택하셨습니다.'
                      : null
                }
              />
            ) : null,
        }}
      />
    </div>
  )
}
export default ProductOptionComponent
